const FEATURE_HELP_URLS = {
  agent_bots: 'https://docs.antive.id/hc/agent-bots',
  agents: 'https://docs.antive.id/hc/agents',
  audit_logs: 'https://docs.antive.id/hc/audit-logs',
  campaigns: 'https://docs.antive.id/hc/campaigns',
  canned_responses: 'https://docs.antive.id/hc/canned',
  channel_email: 'https://docs.antive.id/hc/email',
  channel_facebook: 'https://docs.antive.id/hc/fb',
  custom_attributes: 'https://docs.antive.id/hc/custom-attributes',
  dashboard_apps: 'https://docs.antive.id/hc/dashboard-apps',
  help_center: 'https://docs.antive.id/hc/help-center',
  inboxes: 'https://docs.antive.id/hc/inboxes',
  integrations: 'https://docs.antive.id/hc/integrations',
  labels: 'https://docs.antive.id/hc/labels',
  macros: 'https://docs.antive.id/hc/macros',
  reports: 'https://docs.antive.id/hc/reports',
  sla: 'https://docs.antive.id/hc/sla',
  team_management: 'https://docs.antive.id/hc/teams',
  webhook: 'https://docs.antive.id/hc/webhooks',
  billing: 'https://docs.antive.id/pricing',
  saml: 'https://docs.antive.id/hc/saml',
  captain: 'https://docs.antive.id/captain-docs',
  captain_billing: 'https://docs.antive.id/hc/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
